import { Helmet } from 'react-helmet-async';

const defaultMeta = {
  title: 'Master Castles | Bouncy Castle Hire Auckland NZ',
  description: 'Premium bouncy castle hire for birthdays, parties and events in Auckland, New Zealand. Safe, clean, and professionally delivered inflatables.',
  keywords: 'bouncy castle hire, Auckland, New Zealand, party hire, inflatable hire, kids parties, birthday parties, bouncy castle rental',
};

export default function SEO({ 
  title, 
  description = defaultMeta.description,
  keywords = defaultMeta.keywords,
  noIndex = false 
}) {
  const fullTitle = title 
    ? `${title} | Master Castles Auckland`
    : defaultMeta.title;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Master Castles" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
